import type { ComponentType } from 'react';
import FunnelWidget from './FunnelWidget';
import FunnelTableWidget from './FunnelTableWidget';
import FunnelColumnChartWidget from './FunnelColumnChartWidget';
import type { GenericWidgetProps } from '../ReportcenterWidget';

const widgetMap: { [displayType: string]: ComponentType<GenericWidgetProps> } = {
	funnel: FunnelWidget,
	table: FunnelTableWidget,
	columnChart: FunnelColumnChartWidget
};

const getFunnelWidget = (displayType: string) => widgetMap[displayType] ?? null;

export default getFunnelWidget;
